/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "qqlmicigphkprriivklh"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFxbG1pY2lncGhrcHJyaWl2a2xoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMxMDM5MDIsImV4cCI6MjA2ODY3OTkwMn0.hkWrJP6nD21Wg3MrCR6d-zVgQWDxJPw6hp-iC8jtKpY"